import * as Blockly from 'blockly/core';

export const GLOW_COLOUR = 'rgba(255, 255, 255, 0.7)';

export function darken(hex: string, factor = 0.85): string {
    const r = Math.round(parseInt(hex.slice(1, 3), 16) * factor);
    const g = Math.round(parseInt(hex.slice(3, 5), 16) * factor);
    const b = Math.round(parseInt(hex.slice(5, 7), 16) * factor);
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export function lighten(hex: string, factor = 1.15): string {
    const r = Math.min(255, Math.round(parseInt(hex.slice(1, 3), 16) * factor));
    const g = Math.min(255, Math.round(parseInt(hex.slice(3, 5), 16) * factor));
    const b = Math.min(255, Math.round(parseInt(hex.slice(5, 7), 16) * factor));
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export const schoomyTheme = Blockly.Theme.defineTheme('schoomy', {
    name: 'schoomy',
    base: Blockly.Themes.Classic,
    componentStyles: {
        workspaceBackgroundColour: '#f0f0f0',
        toolboxBackgroundColour: '#f5f5f7',
        flyoutBackgroundColour: '#ebedef',
        flyoutOpacity: 0.98,
        scrollbarColour: 'rgba(0, 0, 0, 0.15)',
        scrollbarOpacity: 0.5,
        insertionMarkerColour: '#000000',
        insertionMarkerOpacity: 0.2,
    },
    fontStyle: {
        family: "'Corporate Logo', sans-serif",
        weight: '500',
        size: 13,
    },
});
